export const questionDataStrucutreUpdating = (q) => ({
    ...q,
    id: q.question_id,
    riddle: q.question,
    question: {
        choices: q.choices
    }
})